import { render, staticRenderFns } from "./bankAndUserInfo.vue?vue&type=template&id=1cb50fa9&scoped=true"
import script from "./bankAndUserInfo.vue?vue&type=script&lang=js"
export * from "./bankAndUserInfo.vue?vue&type=script&lang=js"
import style0 from "./bankAndUserInfo.vue?vue&type=style&index=0&id=1cb50fa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb50fa9",
  null
  
)

export default component.exports